export default "__VITE_ASSET__Wz9Of7eD__"